<ion-header class="ion-no-shadow ion-no-border">
    <ion-toolbar>
        <ion-title>
            <svg-icon [applyClass]="true"
                      [src]="'/assets/icons/messages/file.svg'">
            </svg-icon>
            <div class="info">
                <h3>{{ file.name }}</h3>
                <p *ngIf="file.size">{{ getHumanReadableFilesize(file.size) }}</p>
            </div>
        </ion-title>

        <ion-buttons slot="end">

            <a *ngIf="file.file_url"
               (click)="plt.downloadFile(plt.baseLinkPath + plt.apiPrefix + (file.custom ? file.custom : '/attachments/') + file.id + '?token=' + this.userToken, file.name)"
               class="file-link pointer">
                <svg-icon [applyClass]="true"
                          [src]="'/assets/icons/messages/download.svg'">
                </svg-icon>
            </a>

            <ion-button (click)="backClicked()">
                <ion-icon slot="icon-only"
                          name="close">
                </ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-item class="file-wrapper">
    <img *ngIf="!pdf"
         [src]="plt.createSignedLink(file.file_url)" />
    <iframe *ngIf="pdf"
            [src]="'/assets/js/pdfjs/web/viewer.html?file=' + file.file_url | safe:'resourceUrl'"
            [height]="(plt.appHeight - 100) + 'px'"
            width="100%">
    </iframe>

</ion-item>